<script lang="ts">
	import { Locale, type Localized } from "../../../core/schema/Locale.js";
	import { getTenant } from "../getTenant.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./SoftwareMockup.translations.json";

	let className = "";
	export { className as class };

	const translate = getTranslate(translations);
	const tenant = getTenant();

	const zoneColumns = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O"];
	const zoneRows = [
		"eehhhfffefehfhf",
		"ffeehhhhhhhfhff",
		"ehhhhhfeehheheh",
		"ehhhhhfhfhffhff",
		"ffheehhhefhhheh",
		"fhfhhhfeefehhhh",
		"fhhfhhhffhhfhhf",
		"ffhhfhhfhhfhhhe",
	].map((row) => Array.from(row));

	type OrderStatus = "shipped" | "packing" | "pending";

	const orderStatuses: Record<
		OrderStatus,
		{ label: keyof typeof translations; color: string; width: Localized<number> }
	> = {
		shipped: { label: "orderStatusShipped", color: "#10B981", width: { [Locale.cs]: 50.49, [Locale.en]: 35.22 } },
		packing: { label: "orderStatusPacking", color: "#F59E0B", width: { [Locale.cs]: 31.49, [Locale.en]: 36.83 } },
		pending: { label: "orderStatusPending", color: "#E4E0FF", width: { [Locale.cs]: 26.49, [Locale.en]: 36.41 } },
	};

	const orders: { id: string; customer: string; status: OrderStatus; minutesAgo: number }[] = [
		{ id: "#ORD-2026-001", customer: "Alza.cz a.s.", status: "shipped", minutesAgo: 5 },
		{ id: "#ORD-2026-002", customer: "Rohlík.cz", status: "packing", minutesAgo: 12 },
		{ id: "#ORD-2026-003", customer: "Mall Group", status: "pending", minutesAgo: 15 },
		{ id: "#ORD-2026-004", customer: "CZC.cz", status: "packing", minutesAgo: 24 },
		{ id: "#ORD-2026-005", customer: "Datart", status: "pending", minutesAgo: 30 },
	];
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 1112 640"
	fill="none"
	font-family="Inter"
	role="img"
	aria-label={translate("alt")}
	class={className}
>
	<g clip-path="url(#software-mockup-screen)">
		<path fill="#0D0078" d="M128.72 36.5h854v534h-854z" />

		<path fill="#0A0054" d="M128.72 36.5h37.95v534h-37.95z" />
		<path fill="#E4E0FF" fill-opacity=".2" d="M166.07 36.5h.6v534h-.6z" />
		<path
			stroke="#E4E0FF"
			stroke-linecap="round"
			stroke-width="1.19"
			d="M152.44 67.34v-8.7a.8.8 0 0 0-.8-.8h-7.9a.8.8 0 0 0-.8.8v8.7m0-6.33h9.5m-9.5 3.17h9.5m3.16 1.58a1.6 1.6 0 0 1-1.58 1.58h-12.65a1.6 1.6 0 0 1-1.59-1.58v-8.7a1.6 1.6 0 0 1 .9-1.43l6.29-3.14a1.6 1.6 0 0 1 1.45 0l6.29 3.14a1.6 1.6 0 0 1 .9 1.43z"
		/>
		<rect width="28.47" height="28.47" x="133.46" y="93.43" fill="#fff" fill-opacity=".1" rx="4.74" />
		<path
			stroke="#E4E0FF"
			stroke-linecap="round"
			stroke-width="1.19"
			d="M145.92 102.33h-2.97a.6.6 0 0 0-.6.6v4.14c0 .33.28.6.6.6h2.97a.6.6 0 0 0 .6-.6v-4.15a.6.6 0 0 0-.6-.6Zm6.52 0h-2.96a.6.6 0 0 0-.6.6v1.77c0 .33.27.6.6.6h2.96a.6.6 0 0 0 .6-.6v-1.78a.6.6 0 0 0-.6-.6Zm0 5.34h-2.96a.6.6 0 0 0-.6.59v4.15c0 .33.27.6.6.6h2.96a.6.6 0 0 0 .6-.6v-4.15a.6.6 0 0 0-.6-.6Zm-6.52 2.37h-2.97a.6.6 0 0 0-.6.6v1.77c0 .33.28.6.6.6h2.97a.6.6 0 0 0 .6-.6v-1.78a.6.6 0 0 0-.6-.6Z"
		/>
		<g stroke="#fff" stroke-linecap="round" stroke-opacity=".4" stroke-width="1.19">
			<path
				d="m142.54 137.91 5.16 2.97m0 0 5.16-2.97m-5.16 2.97v5.93m5.33-8.3a1.2 1.2 0 0 0-.59-1.03l-4.15-2.37a1.2 1.2 0 0 0-1.19 0l-4.15 2.37a1.2 1.2 0 0 0-.6 1.03v4.74a1.2 1.2 0 0 0 .6 1.03l4.15 2.37a1.2 1.2 0 0 0 1.19 0l4.15-2.37a1.2 1.2 0 0 0 .6-1.03z"
			/>
			<path
				d="M141.8 168.19h1.18l1.58 7.36a1.2 1.2 0 0 0 1.19.94h5.8a1.2 1.2 0 0 0 1.15-.93l.98-4.4h-10.06m2.3 8.27a.6.6 0 1 1-1.19 0 .6.6 0 0 1 1.19 0Zm6.52 0a.6.6 0 1 1-1.18 0 .6.6 0 0 1 1.18 0Z"
			/>
			<path
				d="M148.88 210.86v-7.12a1.2 1.2 0 0 0-1.18-1.18h-4.75a1.2 1.2 0 0 0-1.18 1.18v6.52a.6.6 0 0 0 .59.6h1.18m0 0a1.19 1.19 0 0 0 2.38 0m-2.37 0a1.19 1.19 0 0 1 2.37 0m0 0h3.56m0 0a1.19 1.19 0 0 0 2.37 0m-2.37 0a1.19 1.19 0 0 1 2.37 0m0 0h1.19a.6.6 0 0 0 .59-.6v-2.16a.6.6 0 0 0-.13-.37l-2.07-2.58a.6.6 0 0 0-.46-.22h-2.09"
			/>
			<path d="M143.55 245.85v-3.56m4.15 3.56v-7.12m4.15 7.12v-10.68" />
		</g>

		<path fill="#E4E0FF" fill-opacity=".2" d="M166.67 78.6h816.05v.6H166.67z" />
		<text x="185.65" y="62.55" font-family="JetBrains Mono" font-size="13.05" font-weight="800">
			<tspan fill="#E4E0FF">VERTI</tspan><tspan fill="#fff">NODE</tspan>
		</text>
		<rect width="189.78" height="23.72" x="661.47" y="45.99" fill="#fff" fill-opacity=".05" rx="4.74" />
		<rect
			width="189.19"
			height="23.13"
			x="661.76"
			y="46.29"
			stroke="#E4E0FF"
			stroke-opacity=".2"
			stroke-width=".59"
			rx="4.45"
		/>
		<path
			stroke="#E4E0FF"
			stroke-linecap="round"
			stroke-width="1.19"
			d="m679.26 61.4-1.72-1.7m.93-2.25a3.16 3.16 0 1 1-6.33 0 3.16 3.16 0 0 1 6.33 0Z"
		/>
		<text x="685.19" y="60.65" fill="#fff" font-size="7.71" opacity=".4">{translate("search")}</text>
		<path
			stroke="#fff"
			stroke-linecap="round"
			stroke-width="1.19"
			d="M870.56 62.3a1 1 0 0 0 1.35.36 1 1 0 0 0 .36-.36m-5.18-2.8a.5.5 0 0 0 .37.82h7.9a.5.5 0 0 0 .37-.83c-.65-.67-1.35-1.4-1.35-3.62a2.97 2.97 0 0 0-5.93 0c0 2.23-.7 2.95-1.36 3.62Z"
		/>
		<rect width="18.98" height="18.98" x="886.83" y="48.36" fill="#E4E0FF" rx="9.49" />
		<g font-size="8.3" font-weight="600">
			<text x="890.82" y="60.87" fill="#0D0078">JS</text>
			<text x="911.74" y="60.87" fill="#fff">Jan Svoboda</text>
		</g>

		<g fill="#E4E0FF">
			<rect width="185.63" height="94.89" x="185.65" y="98.18" rx="7.12" />
			<rect width="185.63" height="94.89" x="383.14" y="98.18" rx="7.12" />
			<rect width="185.63" height="94.89" x="580.63" y="98.18" rx="7.12" />
			<rect width="185.63" height="94.89" x="778.11" y="98.18" rx="7.12" />
		</g>
		<g fill="#0D0078">
			<g font-size="6.52" font-weight="600" opacity=".6" class="uppercase">
				<text x="197.51" y="117.75">{translate("occupancyLabel")}</text>
				<text x="395" y="117.75">{translate("activeOrdersLabel")}</text>
				<text x="592.48" y="117.75">{translate("outboundLabel")}</text>
				<text x="789.97" y="117.75">{translate("inboundLabel")}</text>
			</g>
			<g font-size="18.98" font-weight="700">
				<text x="197.51" y="146.23">{translate("occupancyValue")}</text>
				<text x="395" y="146.23">142</text>
				<text x="592.48" y="146.23">{translate("outboundValue")}</text>
				<text x="789.97" y="146.23">{translate("inboundValue")}</text>
			</g>
			<g font-size="7.71" opacity=".7">
				<text x="197.51" y="160.51">{translate("occupancyNote")}</text>
				<text x="395" y="160.51">{translate("activeOrdersNote")}</text>
				<text x="592.48" y="160.51">{translate("outboundNote")}</text>
				<text x="789.97" y="160.51">{translate("inboundNote")}</text>
			</g>
			<path
				d="M359.41 145.02a14.23 14.23 0 1 1-28.46 0 14.23 14.23 0 0 1 28.46 0m-25.62 0a11.39 11.39 0 1 0 22.78 0 11.39 11.39 0 0 0-22.78 0"
				opacity=".1"
			/>
			<path d="M345.18 130.78a14.23 14.23 0 1 1-13.98 11.57l2.8.53a11.39 11.39 0 1 0 11.18-9.25z" />
		</g>
		<g stroke="#0D0078" stroke-linecap="round" stroke-width="1.19">
			<path
				d="M358.17 117.1a4.44 4.44 0 1 1-5.87-5.8m5.78 4.08c.25 0 .45-.2.42-.45a4.44 4.44 0 0 0-3.98-3.98.4.4 0 0 0-.44.42v3.56q0 .18.13.32.13.12.31.13z"
			/>
			<path
				d="M553.34 114.49a1.78 1.78 0 0 1-3.56 0m-2.18-1.77h7.92m-7.78-.25a1 1 0 0 0-.18.53v5.94a.9.9 0 0 0 .89.89h6.22a.9.9 0 0 0 .9-.9V113a1 1 0 0 0-.18-.53l-.9-1.19a1 1 0 0 0-.7-.35h-4.45a.9.9 0 0 0-.71.35z"
			/>
			<path
				d="M749.05 119.82v-4.44m0 0-3.87-2.23m3.87 2.23 3.87-2.23m-5.87-1.21 4 2.29m-2.44 5.47a.9.9 0 0 0 .88 0l3.12-1.78a.9.9 0 0 0 .44-.77v-3.55a.9.9 0 0 0-.44-.77l-3.12-1.78a.9.9 0 0 0-.88 0l-3.12 1.78a.9.9 0 0 0-.44.77v3.56a.9.9 0 0 0 .44.77z"
			/>
			<path
				d="M947.43 118.05v-5.34a.9.9 0 0 0-.9-.9h-3.55a.9.9 0 0 0-.89.9v4.89q0 .18.13.32.13.12.31.13h.9m0 0a.89.89 0 0 0 1.77 0m-1.78 0a.9.9 0 0 1 1.78 0m0 0h2.67m0 0a.89.89 0 1 0 1.78 0m-1.78 0a.89.89 0 1 1 1.78 0m0 0h.9a.44.44 0 0 0 .44-.45v-1.62q0-.16-.1-.28l-1.55-1.94a.4.4 0 0 0-.35-.16h-1.56"
			/>
		</g>

		<g fill="#0A0054">
			<rect width="529.01" height="272.81" x="185.65" y="212.04" rx="7.12" />
			<rect width="237.22" height="272.81" x="726.52" y="212.04" rx="7.12" />
			<rect width="778.09" height="184.61" x="185.65" y="503.83" rx="7.12" />
		</g>
		<g stroke="#E4E0FF" stroke-opacity=".2" stroke-width=".59">
			<rect width="528.41" height="272.21" x="185.94" y="212.34" rx="6.82" />
			<rect width="236.63" height="272.21" x="726.81" y="212.34" rx="6.82" />
			<rect width="777.5" height="184.02" x="185.94" y="504.12" rx="6.82" />
		</g>
		<g fill="#fff" font-size="10.68" font-weight="700">
			<text x="199.88" y="236.66">{translate("zoneMapHeadline")}</text>
			<text x="740.75" y="236.66">{translate("currentOrdersHeadline")}</text>
			<text x="199.88" y="528.44">{translate("activityLogHeadline")}</text>
		</g>

		<rect width="7.12" height="7.12" x="632.58" y="229.22" fill="#E4E0FF" rx="1.19" />
		<rect
			width="6.52"
			height="6.52"
			x="669.04"
			y="229.52"
			fill="#0D0078"
			stroke="#E4E0FF"
			stroke-width=".59"
			rx=".89"
		/>
		<g fill="#fff" font-size="7.71" opacity=".6">
			<text x="643.26" y="235.58">{translate("zoneFull")}</text>
			<text x="679.42" y="235.58">{translate("zoneEmpty")}</text>
		</g>
		{#each zoneRows as zones, row (row)}
			{#each zones as zone, column (column)}
				{@const x = 199.88 + column * 33.6}
				{@const y = 251.14 + row * 25.4}
				{#if zone === "e"}
					<rect
						width="29.46"
						height="21.25"
						x={x + 0.3}
						y={y + 0.3}
						fill="#0D0078"
						stroke="#E4E0FF"
						stroke-width=".59"
						opacity=".2"
						rx=".89"
					/>
				{:else}
					<rect
						width="30.05"
						height="21.84"
						{x}
						{y}
						fill="#E4E0FF"
						opacity={zone === "h" ? 0.5 : undefined}
						rx="1.19"
					/>
				{/if}
			{/each}
		{/each}
		<g fill="#fff" font-size="6.52" font-weight="600" opacity=".4" text-anchor="middle">
			{#each zoneColumns as zoneColumn, column (zoneColumn)}
				<text x={214.9 + column * 33.6} y="468.99">{zoneColumn}</text>
			{/each}
		</g>

		<text x="949.5" y="235.15" fill="#E4E0FF" font-size="6.52" font-weight="600" text-anchor="end" class="uppercase">
			{translate("viewAll")}
		</text>
		{#each orders as order, index (order.id)}
			{@const top = 248.77 + index * 34.42}
			{@const status = orderStatuses[order.status]}
			{@const statusWidth = status.width[tenant.locale]}
			<rect width="208.76" height=".6" x="740.75" y={top + 33.82} fill="#E4E0FF" fill-opacity=".2" />
			<text x="740.75" y={top + 15.13} fill="#fff" font-size="8.3" font-weight="600">{order.id}</text>
			<text x="740.75" y={top + 25.6} fill="#fff" font-size="7.71" opacity=".6">{order.customer}</text>
			<rect
				width={statusWidth}
				height="11.74"
				x={949.5 - statusWidth}
				y={top + 7.15}
				fill={status.color}
				fill-opacity=".13"
				rx="2.37"
			/>
			<text
				x={949.5 - statusWidth / 2}
				y={top + 15.18}
				fill={status.color}
				font-size="5.93"
				font-weight="600"
				text-anchor="middle"
				class="uppercase"
			>
				{translate(status.label)}
			</text>
			<text
				x="949.5"
				y={top + 26.21}
				fill="#fff"
				font-size="5.34"
				font-weight="600"
				opacity=".4"
				text-anchor="end"
				class="uppercase"
			>
				{translate("minutesAgo", { minutes: order.minutesAgo })}
			</text>
		{/each}

		<path fill="#fff" fill-opacity=".03" d="M199.88 540.55H949.5v17.49H199.88z" />
		<g fill="#E4E0FF" font-size="6.52" font-weight="600" class="uppercase">
			<text x="207" y="551.67">{translate("activityLogTime")}</text>
			<text x="278.17" y="551.67">{translate("activityLogAction")}</text>
			<text x="746.68" y="551.67">{translate("activityLogUser")}</text>
			<text x="853.43" y="551.67">{translate("activityLogSku")}</text>
		</g>
		<path fill="#fff" fill-opacity=".1" d="M199.88 580.67h749.63v.6H199.88z" />
		<text x="207" y="572.22" fill="#fff" font-family="JetBrains Mono" font-size="7.12" opacity=".7">09:42:11</text>
		<text x="278.17" y="572.46" fill="#fff" font-size="7.71">{translate("palletReceived")}</text>
		<text x="746.68" y="572.46" fill="#fff" font-size="7.71" opacity=".8">K. Novák</text>
		<text x="853.43" y="572.22" fill="#E4E0FF" font-family="JetBrains Mono" font-size="7.12">VNT-882-X</text>
	</g>

	<path
		fill="#000"
		fill-opacity=".4"
		d="M118.19 626.74h875.6c9.44 0 32.31 2.47 51.07 5.52s25.16 5.53 14.3 5.53H52.81c-10.86 0-4.45-2.48 14.3-5.53 18.77-3.05 41.63-5.52 51.08-5.52"
		filter="url(#software-mockup-floor-shadow)"
	/>
	<path
		fill="#3A4245"
		fill-rule="evenodd"
		d="M108.45 14.48c-2.9 5.68-2.9 13.1-2.9 27.96v533c0 14.86 0 22.3 2.9 27.97A26.5 26.5 0 0 0 120.04 615c5.67 2.9 13.1 2.9 27.96 2.9h815.42c14.86 0 22.29 0 27.96-2.9 5-2.54 9.05-6.6 11.59-11.6 2.9-5.67 2.9-13.1 2.9-27.95v-533c0-14.86 0-22.3-2.9-27.97A26.5 26.5 0 0 0 991.38 2.9C985.71 0 978.28 0 963.42 0H148c-14.86 0-22.29 0-27.96 2.9-5 2.54-9.05 6.6-11.6 11.6m874.2 22H129.32v533.88h853.33z"
		filter="url(#software-mockup-lid-shadow)"
	/>
	<g fill-rule="evenodd">
		<path
			fill="#262C2D"
			d="M110.42 15.49c-2.65 5.2-2.65 12-2.65 25.63v535.65c0 13.62 0 20.43 2.65 25.63a24.3 24.3 0 0 0 10.62 10.63c5.2 2.65 12.02 2.65 25.63 2.65h818.08c13.62 0 20.43 0 25.63-2.65A24.3 24.3 0 0 0 1001 602.4c2.66-5.2 2.66-12 2.66-25.63V41.12c0-13.62 0-20.43-2.66-25.63a24.3 24.3 0 0 0-10.62-10.63c-5.2-2.65-12.01-2.65-25.63-2.65H146.67c-13.61 0-20.42 0-25.63 2.65a24.3 24.3 0 0 0-10.62 10.63m872.23 20.99H129.32v533.88h853.33z"
		/>
		<path fill="#262C2D" d="M555.7 24.87a3.04 3.04 0 1 0 0-6.08 3.04 3.04 0 0 0 0 6.08" />
		<path fill="#121515" d="M555.7 23.73a1.9 1.9 0 1 0 0-3.8 1.9 1.9 0 0 0 0 3.8" />
		<path fill="#636F73" d="M555.7 21.45a.38.38 0 1 0 0-.76.38.38 0 0 0 0 .76" opacity=".4" />
		<path
			fill="#121515"
			d="M112.39 16.5c-2.41 4.72-2.41 10.91-2.41 23.3v538.3c0 12.38 0 18.57 2.4 23.3a22 22 0 0 0 9.67 9.66c4.73 2.41 10.92 2.41 23.3 2.41h820.72c12.38 0 18.57 0 23.3-2.4a22 22 0 0 0 9.66-9.67c2.41-4.73 2.41-10.92 2.41-23.3V39.8c0-12.39 0-18.58-2.4-23.3a22 22 0 0 0-9.67-9.67c-4.73-2.4-10.92-2.4-23.3-2.4H145.35c-12.38 0-18.57 0-23.3 2.4a22 22 0 0 0-9.66 9.66m870.26 19.98H129.32v533.88h853.33z"
		/>
	</g>
	<path fill="#262C2D" d="M109.98 584.18h891.47v16.58H109.98z" />
	<path fill="url(#software-mockup-base-left)" d="M0 601.86c0-.6.49-1.1 1.1-1.1h553.5c.61 0 1.1.5 1.1 1.1v16.03H0z" />
	<path
		fill="url(#software-mockup-base-right)"
		d="M1111.15 601.86c0-.6-.5-1.1-1.11-1.1h-553.5c-.61 0-1.1.5-1.1 1.1v16.03h555.71z"
	/>
	<path fill="#4E4F53" d="M489.11 612.92h133.2c7.02 0 12.71-5.45 12.71-12.16H476.4c0 6.71 5.7 12.16 12.71 12.16" />
	<path
		fill="url(#software-mockup-notch)"
		d="M489.11 612.92h133.2c7.02 0 12.71-5.45 12.71-12.16H476.4c0 6.71 5.7 12.16 12.71 12.16"
	/>
	<path
		fill="url(#software-mockup-base-bottom)"
		d="M1111.43 617.9c-.06.02-24.41 15.47-104.18 15.47H104.17C24.31 633.37 0 617.89 0 617.89z"
	/>

	<defs>
		<clipPath id="software-mockup-screen">
			<path d="M128.72 36.5h854v534h-854z" />
		</clipPath>
		<linearGradient
			id="software-mockup-base-left"
			x1="-.01"
			x2="555.71"
			y1="609.6"
			y2="609.6"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#303135" />
			<stop offset=".02" stop-color="#535458" />
			<stop offset=".04" stop-color="#4D4E52" />
			<stop offset=".06" stop-color="#333438" />
			<stop offset=".09" stop-color="#35363A" />
			<stop offset=".14" stop-color="#4E4F53" />
			<stop offset=".76" stop-color="#818286" />
			<stop offset="1" stop-color="#818286" />
		</linearGradient>
		<linearGradient
			id="software-mockup-base-right"
			href="#software-mockup-base-left"
			x1="1111.15"
			x2="555.43"
			y1="609.6"
			y2="609.6"
		/>
		<linearGradient
			id="software-mockup-notch"
			x1="476.4"
			x2="635.02"
			y1="606.84"
			y2="606.84"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-opacity=".5" />
			<stop offset=".14" stop-color="#818487" stop-opacity="0" />
			<stop offset=".86" stop-color="#818487" stop-opacity="0" />
			<stop offset="1" stop-opacity=".5" />
		</linearGradient>
		<linearGradient
			id="software-mockup-base-bottom"
			x1="555.71"
			x2="555.71"
			y1="617.89"
			y2="633.37"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#303135" />
			<stop offset="1" stop-color="#08090D" />
		</linearGradient>
		<filter
			id="software-mockup-floor-shadow"
			width="1033.51"
			height="27.63"
			x="39.23"
			y="618.45"
			color-interpolation-filters="sRGB"
			filterUnits="userSpaceOnUse"
		>
			<feGaussianBlur stdDeviation="4.15" />
		</filter>
		<filter
			id="software-mockup-lid-shadow"
			width="904.73"
			height="622.31"
			x="103.34"
			y="-1.11"
			color-interpolation-filters="sRGB"
			filterUnits="userSpaceOnUse"
		>
			<feDropShadow stdDeviation=".55" dx="0" dy="0" flood-color="#001540" flood-opacity=".14" />
			<feDropShadow stdDeviation="1.11" dx="0" dy="1.11" flood-color="#001540" flood-opacity=".05" />
		</filter>
	</defs>
</svg>
